
import {
	ChangeDetectorRef,
	Component,
} from '@angular/core';
import { Tabs } from './tabs';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';

/**
 * This component inherits all of its properties from Tabs
 * This is for the light styling of the component
 */
@AutoUnsubscribe()
@Component({
	selector: 'tabs',
	templateUrl: './tabs.component.html',
	styleUrls: ['./tabs.component.css']
})
export class TabsComponent extends Tabs {
	constructor(
		changeDetector: ChangeDetectorRef
	) {
		super(changeDetector);
	}
}